/* @format */

/**
 * @typedef {Object} CustomFieldInputTypeDefinition
 * @property {string} label - The label to display for the input type.
 * @property {string} value - The value representing the input type.
 * @property {string} valueKey - The CustomFieldValue column name for the input type.
 * @property {string} color - The color to associated with the input type.
 * @property {string} description - The description to display for the input type.
 */

export const CustomFieldInputType = Object.freeze({
    SingleLineText: 'single-line text',
    MultiLineText: 'multi-line text',
    DatePicker: 'date picker',
    SingleCheckbox: 'single checkbox',
    MultipleCheckboxes: 'multiple checkboxes',
    Number: 'number',
    Url: 'url',
    Dropdown: 'single dropdown',
});

export const CustomFieldInputTypeDefinitions = Object.freeze({
    [CustomFieldInputType.SingleLineText]: {
        label: 'Single-line Text',
        value: CustomFieldInputType.SingleLineText,
        valueKey: 'ShortStringValue',
        color: '#F66A7B',
        description: 'Add text like keywords, names, locations, etc',
    },
    [CustomFieldInputType.MultiLineText]: {
        label: 'Multi-line Text',
        value: CustomFieldInputType.MultiLineText,
        valueKey: 'LongStringValue',
        color: '#7E5DFF',
        description: 'Add multiple lines of text',
    },
    [CustomFieldInputType.DatePicker]: {
        label: 'Date Picker',
        value: CustomFieldInputType.DatePicker,
        valueKey: 'DateTimeValue',
        color: '#18AEFF',
        description: 'Add dates like anniversaries, deadlines, contract start, etc.',
    },
    [CustomFieldInputType.SingleCheckbox]: {
        label: 'Single Checkbox',
        value: CustomFieldInputType.SingleCheckbox,
        valueKey: 'ObjectValueJson',
        color: '#2ADA2B',
        description: 'Add one item to mark off',
    },
    [CustomFieldInputType.MultipleCheckboxes]: {
        label: 'Multiple Checkboxes',
        value: CustomFieldInputType.MultipleCheckboxes,
        valueKey: 'ObjectValueJson',
        color: '#EB7E0A',
        description: 'Add multiple items to mark off',
    },
    [CustomFieldInputType.Number]: {
        label: 'Number',
        value: CustomFieldInputType.Number,
        valueKey: 'DoubleValue',
        color: '#F66A7B',
        description: 'Add a custom number fields for costs, estimates, etc.',
    },
    [CustomFieldInputType.Url]: {
        label: 'URL',
        value: CustomFieldInputType.Url,
        valueKey: 'ShortStringValue',
        color: '#7E5DFF',
        description: 'Add a hyperlink to any website',
    },
    [CustomFieldInputType.Dropdown]: {
        label: 'Dropdown',
        value: CustomFieldInputType.Dropdown,
        valueKey: 'ObjectValueJson',
        color: '#18AEFF',
        description: 'Add a dropdown with multiple options to choose from',
    },
});
